<template>
  <div id="app">
		<router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>

<style lang="less" scoped>
	.container{
		
	}
	#app{
		width: 100%;
		height: 100vh;
	}
</style>
